// extracted by mini-css-extract-plugin
export default {"Container":"ResolutionSelectionWrap_Container__t-74S","Header":"ResolutionSelectionWrap_Header__-MCDC","Content":"ResolutionSelectionWrap_Content__3Tzd9"};